import ApplicationTitle from '../../components/ApplicationTitle';
import SelectInput from '../../components/input_fields/SelectInput';
import TextSelectInput from '../../components/input_fields/TextSelectInput';
import StackedTitle from '../../components/form_titles/StackedTitle';
import DoubleButton from '../../components/buttons/DoubleButton';
import ProgressBar from '../../components/progress/ProgressBar';

import validator from "validator";
import React, { useState } from "react";
import { data } from '../../constants';
import TextInput from '../../components/input_fields/TextInput';
import SearchableSelect from '../../components/input_fields/SearchableSelect';
import TextSelectSearch from '../../components/input_fields/seachable/TextSelectSearch';

export default function Step3({ nextStep, handleFormData, prevStep, values, validation, color }) {

  const [taxError, setTaxError] = useState(false)
  const [busStartError, setBusStartError] = useState(false)
  const [stateOfIncorpError, setStateOfIncorpError] = useState(false)
  const [taxStatusError, setTaxStatusError] = useState(false)
  const [taxFilingTypeError, setTaxFilingTypeError] = useState(false)

  const submitFormData = (e) => {
    e.preventDefault();
    // Tax ID Error
    if (validation) {

      // Bus Date Error
      if (!values.busStart.match(/(\d{4}(\/|-)\d{1,2}(\/|-)\d{1,2})/)) {
        setBusStartError(true)
        return
      } setBusStartError(false)
      
      // State Error
      if (!data.states.includes(values.incorpStateCode)) {
        setStateOfIncorpError(true)
        return
      } setStateOfIncorpError(false)

      // Exempt Error
      if (validator.isEmpty(values.taxStatus)) {
        setTaxStatusError(true)
        return
      } setTaxStatusError(false)

      // Filing Type Error
      if (validator.isEmpty(values.taxFilingType)) {
        setTaxFilingTypeError(true)
        return
      } setTaxFilingTypeError(false)
    }




    nextStep();

  }

  return (
    <div className="bg-white-900 dark:bg-white-900 w-full">
      <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0">
        {/* <ApplicationTitle
          mainTitle="Bipsypay Merchant Application"
          subTitle="Complete the form below to begin your Bipsypay merchant application"
        /> */}
        <ProgressBar
          progress="36%"
          color = {color}
        />
        <div className="bg-white rounded-lg shadow dark:border">
          <div className="p-6 space-y-1 sm:p-8">
            <StackedTitle
              color = {color}
              mainTitle="Tell us about your"
              colorTitle="legal and tax information."
              subText="Complete the information below as it is filed with the IRS."
              modalTitle="Why do you need this..."
              modalDesc="Basically, the government is making 
              sure they get paid. To make sure that 
              businesses pay the required taxes, the 
              IRS requires credit card and third-party 
              payment processors to withhold 28% 
              of your revenue if your Taxpayer 
              Identification Number is incorrect or 
              missing. We don’t want to hold your 
              money so lets make sure everything 
              lines up."
            />
            <form className="space-y-4" onSubmit={submitFormData}>

              <TextInput 
                color = {color}
                placeholder="Federal Tax ID Number" id="taxId" name="taxId" type="Text" value={values.taxId}
                error={taxError} message={"Please enter a valid tax ID number."}
                handleInputChange={handleFormData}
              />
              <TextInput 
                color = {color}
                placeholder="Date Business Started (yyyy-mm-dd)" id="bus_start_date" name="busStart" type="Text" value={values.busStart}
                error={busStartError} message={"Please enter a valid start date (yyyy-mm-dd)"}
                handleInputChange={handleFormData}
              />
              {/* <TextSelectInput
                placeholder1="Incorporation State" name1="stateOfIncorp" type1="Text" value1 = {values.stateOfIncorp}
                error1={stateOfIncorpError} message1={"Please enter a valid state."}
                handleInputChange1={handleFormData}
                placeholder2="IRS Filing Status" name2="taxStatus" options={["Tax Exempt", "Not Tax Exempt"]} value2 = {values.taxStatus}
                error2={taxStatusError} message2={"Please choose a tax status."}
                handleInputChange2={handleFormData}
              /> */}
              <TextSelectSearch
                color = {color}
                placeholder1="Incorporation State" name1="incorpStateCode" type1="Text" value1={values.incorpStateCode}
                error1={stateOfIncorpError} message1={"Please enter a valid state."}
                handleInputChange1={handleFormData}
                placeholder2="IRS Filing Status" name2="taxStatus" options={["Tax Exempt", "Not Tax Exempt"]} value2={values.taxStatus}
                error2={taxStatusError} message2={"Please choose a tax status."}
                handleInputChange2={handleFormData}
              />

              <SelectInput 
                color = {color}
                placeholder="Tax ID Type" name="taxFilingType" options={["Sole Proprietor", "LLC", "Partnership", "S-Corp", "Corporation"]} value={values.taxFilingType}
                error={taxFilingTypeError} message={"Please choose a filing type."}
                handleInputChange={handleFormData} />

              <DoubleButton color = {color} prevStep={prevStep}></DoubleButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}